import {
  PencilAltIcon,
  StarIcon,
  ViewGridIcon,
  ShoppingBagIcon,
} from "@heroicons/react/solid";
import { StarIcon as Staroutline } from "@heroicons/react/outline";
import React, { useEffect, useState, forwardRef, useContext } from "react";
import { useParams } from "react-router-dom";
import { openDB } from "idb";
import AddNewItem from "./AddNewItem";
import EditMenuItemPopup from "./EditMenuItemPopup";
import VegIco from "../images/veg-sign.png";
import NonVegIco from "../images/non-veg-sign.jpg";
import Context from "../context/context";
import { CSS } from "@dnd-kit/utilities";
import { Delete } from "@mui/icons-material";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  useSortable,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import axios from "axios";
import { v4 as uuid } from "uuid";

// const server = 'http://localhost:5000'
const server = "https://api.myfooddo.com";

export default function MenuItem({
  category,
  setCurrentMenu,
  menus,
  setReload,
  reload,
  currentMenu,
  ItemEditPopup,
  setCategoryId,
  setItemIds,
  AllCategories,
  itemFilter,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const [activeId, setActiveId] = useState(null);
  const [itemId, setItemId] = useState();
  const [menuItemData, setMenuItemData] = useState();
  const [editItemPopupOpen, setEditItemPopupOpen] = useState(false);
  const [editMenuItemPopupOpen, setEditMenuItemPopupOpen] = useState(false);
  const [currencySign, setCurrencySign] = useState(false);
  const [items, setItems] = useState([]);
  const [itemsIdList, setItemsIdList] = useState(null);
  const context = useContext(Context);
  const { updateUnSync } = context;
  const [availableImages, setAvailableImages] = useState([]);
  const [deletePopup, setDeletePopup] = useState(null);

  // Fetching all available items
  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB(
        "FoodDo",
        +localStorage?.getItem("IDBVersion") || 1
      );
      const outlet = await db
        ?.transaction("outlet", "readonly")
        ?.objectStore("outlet")
        ?.get(localStorage?.getItem("outlet_uuid"));

      setCurrencySign(outlet?.setup?.currency_sign);

      let dbItems = await db
        ?.transaction("item", "readonly")
        ?.objectStore("item")
        ?.getAll();

      dbItems = dbItems?.filter(
        (item) => item?.category_uuid === category?.category_uuid
      );

      let menu_items = await currentMenu?.category_and_items?.find(
        (c) => c.category_uuid === category.category_uuid
      )?.menu_items;
      let x = [];
      let ids = [];

      await menu_items
        ?.sort((a, b) => +a?.menu_item_sort_order - +b?.menu_item_sort_order)
        ?.forEach((menu_item) => {
          const item = dbItems?.find(
            (i) => menu_item?.item_uuid === i?.item_uuid
          );
          if (item) {
            ids.push(menu_item.item_uuid);
            x?.push({ ...item, ...menu_item });
          }
        });

      try {
        let url = `${server}/item/available-item-images`;
        let res = await fetch(url, {
          method: "post",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(ids),
        });

        if (res.ok) {
          res = await res.json();
          setAvailableImages(res);
        }
      } catch (err) {
        console.error(err.message);
      }
      console.log({
        ids, x, menu_items: menu_items?.filter(i => !dbItems?.find(j => j?.item_uuid === i?.item_uuid))
      })
      setItemsIdList(ids);
      setItems(x);
    };

    if (category && menus && currentMenu) getDataFromIndexdDb();
  }, [category, menus, reload, currentMenu]);

  // Adding/Editing new item added to menu in unsynced_files collection in IndexedDB
  const handleMenuUnsyncedFile = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const tx = await db
      ?.transaction("unsynced_files", "readwrite")
      ?.objectStore("unsynced_files");
    const allUnsyncedFiles = await tx?.getAll();
    const ndata = {
      ...data,
      RECON_TIME: new Date()?.getTime()?.toString(),
      IDENTIFIER: "menu-edit:" + data?.menu_uuid,
    };
    let currentUnsyncedFile = allUnsyncedFiles?.find(
      (curr) => curr?.IDENTIFIER === "menu-edit:" + data?.menu_uuid
    );
    currentUnsyncedFile ? await tx?.put(ndata) : await tx?.add(ndata);

    handleMenuReconciliation(ndata);
    updateUnSync();
  };

  // Adding/Editing menu to reconciliation collection in IndexedDB
  const handleMenuReconciliation = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const tx = await db
      ?.transaction("reconciliation", "readwrite")
      ?.objectStore("reconciliation");
    const allReconRecords = await tx?.getAll();

    const menusJsonExists = allReconRecords?.find(
      (curr) => curr?.IDENTIFIER === "menu"
    );
    if (menusJsonExists) {
      const menus = menusJsonExists?.details?.filter(
        (menu) => menu?.menu_uuid !== data?.menu_uuid
      );
      const editData = {
        ...menusJsonExists,
        details: [
          ...menus,
          {
            menu_uuid: data?.menu_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data?.menu_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.add(newdata);
    }
  };

  const handleDBUpdate = async (data) => {
    const menu_doc = await currentMenu;
    const category_index = await menu_doc.category_and_items.findIndex(
      (object) => object.category_uuid === category.category_uuid
    );
    menu_doc.category_and_items[category_index].menu_items =
      await menu_doc.category_and_items[category_index].menu_items.map((i) => {
        return {
          ...i,
          menu_item_sort_order: data.indexOf(i.item_uuid),
        };
      });
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const tx = db?.transaction("menu", "readwrite")?.objectStore("menu");
    await tx?.put(menu_doc);
    handleMenuUnsyncedFile(menu_doc);
  };

  const DeleteSeat = async () => {
    console.log(deletePopup)
    const response = await axios({
      method: "delete",
      url: "https://api.myfooddo.com/item/deleteItem",
      // url: "http://localhost:5001/item/deleteItemData",
      data: { item_uuid: deletePopup.item_uuid },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("activity", response);
    if (response.data.success) {
      const db = await openDB(
        "FoodDo",
        +localStorage?.getItem("IDBVersion") || 1
      );
      const indSeats = await db
        ?.transaction("item", "readwrite")
        ?.objectStore("item");
      await indSeats.delete(deletePopup.item_uuid);
      setDeletePopup(response.data.result);
    } else {
      setDeletePopup(response.data.result);
    }
  };

  return (
    <div className="itemmenulist">
      <h1>{category?.category_name}</h1>
      <div className="itemlist">
        {items && itemsIdList && (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={itemsIdList} strategy={rectSortingStrategy}>
              <div className="droppableCate">
                {itemsIdList?.map((id, i) => {
                  const item = items
                    ?.filter((a) =>
                      itemFilter !== ""
                        ? a.item_name
                          .toLowerCase()
                          .includes(itemFilter.toLowerCase())
                        : true
                    )
                    ?.find((j) => j?.item_uuid === id);
                  if (item)
                    return (
                      <SortableItem
                        key={i}
                        i={i}
                        id={id}
                        activeId={activeId}
                        category={category}
                        currentMenu={currentMenu}
                        setCurrentMenu={setCurrentMenu}
                        list={item}
                        itemId={itemId}
                        setItemId={setItemId}
                        setItemIds={setItemIds}
                        currencySign={currencySign}
                        setCategoryId={setCategoryId}
                        ItemEditPopup={ItemEditPopup}
                        menuItemData={menuItemData}
                        setMenuItemData={setMenuItemData}
                        editItemPopupOpen={editItemPopupOpen}
                        setEditItemPopupOpen={setEditItemPopupOpen}
                        editMenuItemPopupOpen={editMenuItemPopupOpen}
                        setEditMenuItemPopupOpen={setEditMenuItemPopupOpen}
                        availableImages={availableImages}
                        setDeletePopup={setDeletePopup}
                      />
                    );
                  else return "";
                })}
              </div>
            </SortableContext>
            <DragOverlay>
              {activeId ? (
                <Item
                  id={activeId}
                  cardClass={"drag-overlay"}
                  category={category}
                  currentMenu={currentMenu}
                  currencySign={currencySign}
                  list={items?.find((i) => i.item_uuid === activeId)}
                  availableImages={availableImages}
                />
              ) : null}
            </DragOverlay>
          </DndContext>
        )}
      </div>

      {editItemPopupOpen && (
        <AddNewItem
          itemId={itemId}
          AllCategories={AllCategories}
          Menu={currentMenu}
          setCurrentMenu={setCurrentMenu}
          close={() => {
            setReload(uuid());
            setEditItemPopupOpen(!editItemPopupOpen)
          }}
          availableImages={availableImages}
          setAvailableImages={setAvailableImages}
        />
      )}
      {editMenuItemPopupOpen && (
        <EditMenuItemPopup
          menuItemData={menuItemData}
          close={() => setEditMenuItemPopupOpen(!editMenuItemPopupOpen)}
          currentMenu={currentMenu}
          setCurrentMenu={setCurrentMenu}
        />
      )}
      {deletePopup && (
        <div className="newCategory">
          <div className="newCatContainer">
            <div className="newCatContainer_header">
              <h2>
                {deletePopup?.item_name
                  ? `Delete Item ${deletePopup.item_name} ?`
                  : deletePopup}
              </h2>
              {/* <XIcon className='closeicon' onClick={close} /> */}
            </div>
            <div
              className="newCatContainer2"
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button onClick={() => setDeletePopup(null)}>
                {deletePopup?.item_name ? "Cancel" : "Okay"}
              </button>
              {deletePopup?.item_name ? (
                <button onClick={() => DeleteSeat()}>Confirm</button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  function handleDragStart(event) {
    const { active } = event;
    setActiveId(active?.id);
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active?.id !== over?.id) {
      const oldIndex = itemsIdList?.indexOf(active.id);
      const newIndex = itemsIdList?.indexOf(over.id);

      let updatedItems = arrayMove(itemsIdList, oldIndex, newIndex);
      setItemsIdList(updatedItems);
      handleDBUpdate(updatedItems);
    }
    setActiveId(null);
  }
}

const SortableItem = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props?.id });

  const style = {
    transform: CSS?.Transform?.toString(transform),
    transition,
  };

  return (
    <Item
      {...props}
      ref={setNodeRef}
      setDeletePopup={props.setDeletePopup}
      style={style}
      {...attributes}
      {...listeners}
    />
  );
};

const Item = forwardRef(({
  i,
  activeId,
  category,
  style,
  currentMenu,
  setCurrentMenu,
  list,
  itemId,
  setItemId,
  setItemIds,
  setCategoryId,
  ItemEditPopup,
  menuItemData,
  setMenuItemData,
  editItemPopupOpen,
  setEditItemPopupOpen,
  editMenuItemPopupOpen,
  setEditMenuItemPopupOpen,
  currencySign,
  cardClass,
  availableImages,
  setDeletePopup,
  ...props
}, ref) => {
  const [hoverState, setHoverState] = useState({ id: "", value: "" });
  const { menuId } = useParams();

  return (
    <div
      key={category?.category_name?.replace(" ", "-")}
      className="droppableCate01"
      ref={ref}
      style={style}
    >
      <div className={`homeItem ${cardClass} ${activeId === list?.item_uuid ? "active" : ""}`}>
        <div className="itemdetails">
          <div className="dragbox">
            <ViewGridIcon {...props} className={`dragicon ${cardClass}`} />
            <input
              className="staricon"
              type="checkbox"
              checked={
                currentMenu?.category_and_items
                  ?.filter((a) => a?.category_uuid === list?.category_uuid)
                  .filter(
                    (a) =>
                      a?.menu_items
                        ?.filter((c) => c?.item_uuid === list?.item_uuid)
                        .filter((c) => +c?.menu_item_status === 1).length
                  ).length
              }
              onChange={(e) =>
                setCurrentMenu({
                  ...currentMenu,
                  category_and_items: currentMenu?.category_and_items?.map(
                    (a) => {
                      if (a?.category_uuid === list?.category_uuid) {
                        return {
                          ...a,
                          menu_items: a?.menu_items?.map((c) => {
                            if (c?.item_uuid === list?.item_uuid) {
                              return {
                                ...c,
                                menu_item_status:
                                  +list?.menu_item_status === 1 ? "0" : "1",
                              };
                            } else return c;
                          }),
                        };
                      } else return a;
                    }
                  ),
                })
              }
              onMouseOver={() =>
                setHoverState({
                  id: list?.item_name,
                  value: "status",
                })
              }
              onMouseLeave={() => setHoverState({ id: "", value: "" })}
            />
            {list?.item_name === hoverState?.id && hoverState?.value === "status" ? (
              <div
                style={{
                  position: "absolute",
                  width: "100px",
                }}
              >
                <HoverData text="Item Status" />
              </div>
            ) : ("")}
            <div className="itemicons" style={{ position: "relative" }}>
              {list?.item_name === hoverState?.id && hoverState?.value === "mark" ? (
                <div
                  style={{
                    position: "absolute",
                    width: "160px",
                    bottom: "150%",
                  }}
                >
                  <HoverData text="Mark Recommended " />
                </div>
              ) : ("")}
              {list?.item_name === hoverState?.id && hoverState?.value === "edit" ? (
                <div
                  style={{
                    position: "absolute",
                    width: "100px",
                  }}
                >
                  <HoverData text="Edit Item " />
                </div>
              ) : ("")}
              {list?.menu_item_recommended === "Y" ? (
                <StarIcon
                  className="staricon"
                  onMouseOver={() =>
                    setHoverState({
                      id: list?.item_name,
                      value: "mark",
                    })
                  }
                  onMouseLeave={() => setHoverState({ id: "", value: "" })}
                />
              ) : (
                <Staroutline
                  className="staricon"
                  onMouseOver={() =>
                    setHoverState({
                      id: list?.item_name,
                      value: "mark",
                    })
                  }
                  onMouseLeave={() => setHoverState({ id: "", value: "" })}
                />
              )}
              <PencilAltIcon
                className="staricon"
                onClick={() => {
                  setEditItemPopupOpen(!editItemPopupOpen);
                  setItemId(list?.item_uuid);
                }}
                onMouseOver={() =>
                  setHoverState({
                    id: list?.item_name,
                    value: "edit",
                  })
                }
                onMouseLeave={() => setHoverState({ id: "", value: "" })}
              />
            </div>
          </div>
          <div className="imageDiv">
            {availableImages?.[0] &&
              availableImages?.includes(list?.item_uuid) ? (
              <div className="itemimage">
                <img
                  src={`${server}/item-images/${list?.item_uuid}.webp`}
                  className="imageitem"
                  alt="itemimage"
                  width="100"
                  height="100"
                />
              </div>
            ) : (
              <div className="alterimage">
                <label htmlFor="alterimage">
                  Choose Image
                  <input
                    style={{ display: "none" }}
                    type="text"
                    id="alterimage"
                  />
                </label>
              </div>
            )}
            <button
              className="addButton"
              style={{ position: "relative" }}
              onMouseOver={() =>
                setHoverState({
                  id: list?.item_name,
                  value: "customization",
                })
              }
              onMouseLeave={() => setHoverState({ id: "", value: "" })}
              onClick={() => {
                setCategoryId(category?.category_uuid);
                setItemIds(list?.item_uuid);
                ItemEditPopup(true);
              }}
            >
              {list?.item_name === hoverState?.id &&
                hoverState?.value === "customization" ? (
                <div
                  style={{
                    position: "absolute",
                    width: "200px",
                    bottom: "200%",
                  }}
                >
                  <HoverData text="Edit Customization " />
                </div>
              ) : (
                ""
              )}
              Add
            </button>
          </div>
          <div className="details" style={{ position: "relative" }}>
            <div
              style={{
                color: "red",
                position: "absolute",
                right: "5px",
                top: "0px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setDeletePopup(list);
              }}
            >
              <Delete style={{ fontSize: "20px" }} />
            </div>
            <span
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {list?.item_mode === "1" && (
                <img className="item-mode" src={VegIco} alt="Veg" />
              )}
              {list?.item_mode === "2" && (
                <img className="item-mode" src={NonVegIco} alt="Non-Veg" />
              )}

              <span
                className={`tag ${!list?.menu_item_label && "disabled"}`}
                style={{ position: "relative" }}
                onMouseOver={() =>
                  setHoverState({
                    id: list?.item_name,
                    value: "tag",
                  })
                }
                onMouseLeave={() => setHoverState({ id: "", value: "" })}
                onClick={() => {
                  setEditMenuItemPopupOpen(!editMenuItemPopupOpen);
                  setMenuItemData({
                    item_uuid: list?.item_uuid,
                    category_uuid: category?.category_uuid,
                    menuId: menuId,
                    menu_item_label: list?.menu_item_label || "Add Tag",
                  });
                }}
              >
                {list?.item_name === hoverState?.id &&
                  hoverState?.value === "tag" ? (
                  <div
                    style={{
                      position: "absolute",
                      width: "150px",
                      bottom: "250%",
                    }}
                  >
                    <HoverData text="Edit Item Tag" />
                  </div>
                ) : (
                  ""
                )}
                {list?.menu_item_label || "Add Tag"}
              </span>
            </span>
            <span className="item-name">{list?.item_name} </span>
            <span
              className="item-desc"
              style={{ position: "relative" }}
              onClick={() => {
                setEditMenuItemPopupOpen(!editMenuItemPopupOpen);
                setMenuItemData({
                  item_uuid: list?.item_uuid,
                  category_uuid: category?.category_uuid,
                  menuId: menuId,
                  menu_item_description: list?.menu_item_description || "-",
                });
              }}
              onMouseOver={() =>
                setHoverState({
                  id: list?.item_name,
                  value: "desc",
                })
              }
              onMouseLeave={() => setHoverState({ id: "", value: "" })}
            >
              {list?.item_name === hoverState?.id &&
                hoverState?.value === "desc" ? (
                <div
                  style={{
                    position: "absolute",
                    width: "150px",
                    bottom: "250%",
                  }}
                >
                  <HoverData text="Edit Description" />
                </div>
              ) : (
                ""
              )}
              {list?.menu_item_description || "NA"}
            </span>
            <div
              style={{
                width: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span
                className={`item-price ${+list?.menu_item_discount > 0 ? "priceWithDiscount" : ""}`}
                style={{ position: "relative" }}
                onClick={() => {
                  setEditMenuItemPopupOpen(!editMenuItemPopupOpen);
                  setMenuItemData({
                    item_uuid: list?.item_uuid,
                    category_uuid: category?.category_uuid,
                    menuId: menuId,
                    menu_item_price: list?.menu_item_price || "0",
                  });
                }}
                onMouseOver={() =>
                  setHoverState({
                    id: list?.item_name,
                    value: "price",
                  })
                }
                onMouseLeave={() => setHoverState({ id: "", value: "" })}
              >
                {list?.item_name === hoverState?.id &&
                  hoverState?.value === "price" ? (
                  <div
                    style={{
                      position: "absolute",
                      width: "100px",
                      bottom: "150%",
                    }}
                  >
                    <HoverData text="Edit Price" />
                  </div>
                ) : (
                  ""
                )}
                {currencySign + " "}
                {list?.menu_item_price || "0"}{" "}
              </span>
              <span
                className={`tagRed ${list?.menu_item_discount === "0" && "disabled"
                  }`}
                style={{ position: "relative" }}
                onMouseOver={() =>
                  setHoverState({
                    id: list?.item_name,
                    value: "discount",
                  })
                }
                onMouseLeave={() => setHoverState({ id: "", value: "" })}
                onClick={() => {
                  setEditMenuItemPopupOpen(!editMenuItemPopupOpen);
                  setMenuItemData({
                    item_uuid: list?.item_uuid,
                    category_uuid: category?.category_uuid,
                    menuId: menuId,
                    menu_item_discount: list?.menu_item_discount ?? "0",
                  });
                }}
              >
                {hoverState?.id === list?.item_name &&
                  hoverState?.value === "discount" ? (
                  <div
                    style={{
                      position: "absolute",
                      width: "120px",
                      bottom: "250%",
                      left: "10%",
                    }}
                  >
                    <HoverData text="Edit Discount" />
                  </div>
                ) : (
                  ""
                )}
                {-(list?.menu_item_discount ?? "0") + "% OFF"}
              </span>
              <span
                className={`item-price ${+list?.menu_item_discount > 0 ? "priceWithDiscount" : ""
                  }`}
                style={{
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                }}
                onClick={() => {
                  console.log('hitted')
                  setEditMenuItemPopupOpen(!editMenuItemPopupOpen);
                  setMenuItemData({
                    item_uuid: list?.item_uuid,
                    category_uuid: category?.category_uuid,
                    menuId: menuId,
                    menu_item_parcel_charge:
                      list?.menu_item_parcel_charge || "0",
                  });
                }}
                onMouseOver={() =>
                  setHoverState({
                    id: list?.item_name,
                    value: "item_parcel_charg",
                  })
                }
                onMouseLeave={() => setHoverState({ id: "", value: "" })}
              >
                {list?.item_name === hoverState?.id &&
                  hoverState?.value === "item_parcel_charg" ? (
                  <div
                    style={{
                      position: "absolute",
                      width: "200px",
                      bottom: "150%",
                    }}
                  >
                    <HoverData text="Edit Item Parcel Charges" />
                  </div>
                ) : (
                  ""
                )}
                <ShoppingBagIcon style={{ height: "20px" }} />
                {currencySign + " "}
                {list?.menu_item_parcel_charge || "0"}{" "}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
);

const HoverData = ({ text }) => (
  <div
    style={{
      textDecoration: "none",
      position: "absolute",
      backgroundColor: "black",
      color: "white",
      padding: "3px 0",
      borderRadius: "20px",
      fontSize: "15px",
      width: "100%",
      textAlign: "center",
      zIndex: "1000000",
      fontWeight: "400",
    }}
  >
    {text}
  </div>
);
